import React from 'react';
import PropTypes from 'prop-types';

import UpgradeSelectionBoxes from './components/UpgradeSelectionBoxes';

const propTypes = {
  stepProps: PropTypes.shape({
    eventAddonItems: PropTypes.array,
    freeEventCreationEnabled: PropTypes.bool,
    isEveryDayShare: PropTypes.bool,
  }),
  setStepProps: PropTypes.func,
  handleSubmit: PropTypes.func,
  disableSubmit: PropTypes.bool,
  onSkip: PropTypes.func,
};

const FreemiumEventCreateSubscriptionUpsellStep = ({
  stepProps,
  setStepProps,
  handleSubmit,
  disableSubmit,
  onSkip,
}) => {
  return (
    <UpgradeSelectionBoxes
      stepProps={stepProps}
      setStepProps={setStepProps}
      handleSubmit={handleSubmit}
      disableSubmit={disableSubmit}
      onSkip={onSkip}
    />
  );
};

FreemiumEventCreateSubscriptionUpsellStep.propTypes = propTypes;

export default FreemiumEventCreateSubscriptionUpsellStep;
